import { Box, BoxProps, ColorOptions, Spacer } from '@jfs/ui-new'
import { FC, useCallback } from 'react'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { convertCamelCaseToString } from '../../utils'

interface EntityDetailsProps {
  id: string
  data: any
  hide: boolean
  onChange: any
}

export const getTextView = (data: any, update?: any, titles?: any, showAllFields?: boolean) => {
  if (!data) {
    return null
  }

  return Object.keys(data).map(function (key, index) {
    if (!showAllFields && !data[key]) {
      return null
    }
    return (
      <Box paddingVertical={8} marginRight={16} minWidth={175}>
        <TextInputWithCb
          testID={'edit-entity-' + index}
          label={titles ? titles[key] : convertCamelCaseToString(key)}
          value={data[key] ?? ''}
          showCheckbox={true}
          onChange={(obj: any, isChecked: any) => update && update(obj, isChecked)}
        />
      </Box>
    )
  })
}
export const getEntityDetails = (data: any, update?: any, showAllFields?: boolean) => {
  const { info, endpoint, contactInfo, ipDetails } = data
  return (
    <Box {...styles.container}>
      <Box paddingHorizontal={24} backgroundColor="WHITE">
        <Spacer direction="vertical" size={16} />
        <Box flexDirection="row" flexWrap="wrap">
          {getTextView(info, update, undefined, showAllFields)}
        </Box>
        <Spacer direction="vertical" size={16} />
        <Box flexDirection="row" flexWrap="wrap">
          {getTextView(endpoint, update, undefined, showAllFields)}
        </Box>
        <Spacer direction="vertical" size={16} />
        <Box flexWrap="wrap">
          {contactInfo?.map((item: any, index: any) => {
            const cInfo = { ...item }
            const id = item.id
            delete cInfo.id
            return (
              <Box flexDirection="row" flexWrap="wrap">
                {getTextView(cInfo, update, undefined, showAllFields)}
              </Box>
            )
          })}
        </Box>
        <Spacer direction="vertical" size={16} />
        <Box flexWrap="wrap">
          {ipDetails?.map((item: any, index: any) => {
            const cInfo = { ...item }
            const id = item.id
            delete cInfo.id
            return (
              <Box flexDirection="row" flexWrap="wrap">
                {getTextView(cInfo, update, undefined, showAllFields)}
              </Box>
            )
          })}
        </Box>
      </Box>
    </Box>
  )
}
const EntityDetails: FC<EntityDetailsProps> = ({ id, data, hide, onChange }: EntityDetailsProps) => {
  const update = useCallback((obj, isChecked) => onChange(obj, isChecked), [onChange])
  if (!hide) {
    return null
  }

  return getEntityDetails(data, update, true)
}

export { EntityDetails }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
